import { Action } from 'redux';
import { PersonalInfoStateStructure } from '../../angular-elements/shared/interfaces/personalInfoStateStructure.interface';

export const PERSONAL_INFO_STATE_NAME = 'personalInfo';
export class PayloadAction implements Action {
  type: string;
  personalInfoStateStructure?: PersonalInfoStateStructure;
  ctrlName?: string;
}

const INITIAL_STATE: PersonalInfoStateStructure = {
  firstName: '',
  middleInitial: '',
  lastName: '',
  dob: '',
  gender: '',
  addressLine1: '',
  addressLine2: '',
  city: '',
  mailingAddressExists: '',
  personalPhoneNumber: '',
  endStageRenalDisease: '',
  county: '',
  countyCode: null,
  state: '',
  zipCode: '',
  mailingAddressLine1: '',
  mailingAddressLine2: '',
  mailingCity: '',
  mailingState: '',
  mailingZipCode: '',
  emailAddress: '',
  suffix: '',
  powerOfAttorney: '',
  powerOfAttyFirstName: '',
  powerOfAttyLastName: '',
  ssn: '',
  raceCodes: {},
  ethnicityCodes: {}
};

export const LOAD_PERSONAL_INFO = 'LOAD_PERSONAL_INFO';
export const INIT_PAYLOAD = 'INIT_PAYLOAD';
export const RESET_PERSONAL_INFO_CONTROL = 'RESET_PERSONAL_INFO_CONTROL';
const RESET_STATE = 'RESET_STATE_PersonalInfo';

export function loadPersonalInfo(info: PersonalInfoStateStructure): PayloadAction {
  return {
    type: LOAD_PERSONAL_INFO,
    personalInfoStateStructure: info
  };
}

export function resetPersonalInfoControl(controlName: string): PayloadAction {
  return {
    type: RESET_PERSONAL_INFO_CONTROL,
    ctrlName: controlName
  };
}

export function resetPersonalInfo(): PayloadAction {
  return { type: RESET_STATE};
}

export function personalInfo( state: PersonalInfoStateStructure = INITIAL_STATE, action: PayloadAction ) {
  const copiedState = JSON.parse(JSON.stringify(Object.assign({}, state)));
  switch (action.type) {
    case RESET_PERSONAL_INFO_CONTROL:
      if (copiedState[action.ctrlName]) {
        copiedState[action.ctrlName] = '';
      }
      return Object.assign({}, state, copiedState);
    case LOAD_PERSONAL_INFO:
      copiedState.firstName = action.personalInfoStateStructure.firstName;
      copiedState.middleInitial = action.personalInfoStateStructure.middleInitial;
      copiedState.lastName = action.personalInfoStateStructure.lastName;
      copiedState.dob = action.personalInfoStateStructure.dob;
      copiedState.gender = action.personalInfoStateStructure.gender;
      copiedState.addressLine1 = action.personalInfoStateStructure.addressLine1;
      copiedState.addressLine2 = action.personalInfoStateStructure.addressLine2;
      copiedState.city = action.personalInfoStateStructure.city;
      copiedState.mailingAddressExists = action.personalInfoStateStructure.mailingAddressExists;
      copiedState.personalPhoneNumber = action.personalInfoStateStructure.personalPhoneNumber;
      copiedState.endStageRenalDisease = action.personalInfoStateStructure.endStageRenalDisease;
      copiedState.county = action.personalInfoStateStructure.county;
      copiedState.countyCode = action.personalInfoStateStructure.countyCode;
      copiedState.state = action.personalInfoStateStructure.state;
      copiedState.zipCode = action.personalInfoStateStructure.zipCode;
      copiedState.mailingAddressLine1 = action.personalInfoStateStructure.mailingAddressLine1;
      copiedState.mailingAddressLine2 = action.personalInfoStateStructure.mailingAddressLine2;
      copiedState.mailingCity = action.personalInfoStateStructure.mailingCity;
      copiedState.mailingState = action.personalInfoStateStructure.mailingState;
      copiedState.mailingZipCode = action.personalInfoStateStructure.mailingZipCode;
      copiedState.emailAddress = action.personalInfoStateStructure.emailAddress;
      copiedState.suffix = action.personalInfoStateStructure.suffix;
      copiedState.powerOfAttorney = action.personalInfoStateStructure.powerOfAttorney;
      copiedState.powerOfAttyFirstName = action.personalInfoStateStructure.powerOfAttyFirstName;
      copiedState.powerOfAttyLastName = action.personalInfoStateStructure.powerOfAttyLastName;
      copiedState.ssn = action.personalInfoStateStructure.ssn;
      copiedState.raceCodes = action.personalInfoStateStructure.raceCodes;
      copiedState.ethnicityCodes = action.personalInfoStateStructure.ethnicityCodes;
      return Object.assign({}, state, copiedState);
    case RESET_STATE:
      return INITIAL_STATE;
    case INIT_PAYLOAD:
    default:
      return state;
  }
}

